// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"86":"0b8110d8","990":"754fc334"}[chunkId] + ".chunk.js";
};